// @ts-check
import { Page as BasePage } from '@react-pdf/renderer';
import React from 'react';
import { Stencil } from '..';
import { ThemeProvider } from '../../useTheme';

/**
 *
 * @param {{
 *  theme: import('../../useTheme').BottlebooksPDFTheme["theme"];
 *  stencil?: string;
 *  size?: import('@react-pdf/types').PageSize;
 *  children: React.ReactNode;
 *  [x: string]: any;
 * }} props
 * @returns
 */
export default function Page({ theme, stencil, children, style, ...rest }) {
  const pages = React.useContext(PagesContext);
  return (
    <ThemeProvider theme={theme}>
      <PageProvider value={pages?.next()}>
        <BasePage size="A4" style={style} {...rest}>
          <Stencil src={stencil} />
          {children}
        </BasePage>
      </PageProvider>
    </ThemeProvider>
  );
}

const PagesContext = React.createContext(undefined);

export function PagesProvider({ children }) {
  const totalPages = React.useRef(0);
  const value = {
    current: totalPages.current,
    reset: () => (totalPages.current = 0),
    next: () => ++totalPages.current,
  };
  return (
    <PagesContext.Provider value={value}>{children}</PagesContext.Provider>
  );
}
const PageContext = React.createContext(0);

/** @returns {{ pageNumber: number, alignment: 'left'|'right' }} */
export function usePage(offset = 0) {
  const pageNumber = React.useContext(PageContext) + offset;
  return {
    pageNumber,
    alignment: pageNumber % 2 === 0 ? 'left' : 'right',
  };
}

export function PageProvider({ children, value }) {
  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
}
